import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
// JSON Lenguages
// EN : English
import * as commonEn from "./en/common.json";

// SV : Swedish
import * as commonSv from "./sv/common.json";

const resources = {
    en: {
        common: commonEn.default,
    },
    sv: {
        common: commonSv.default,
    },
};

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: "en",
        // lng: 'en', lenguage default

        keySeparator: ".",

        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: false,
        },
    });

export default i18n;
